import { Dispatch, Middleware } from 'redux'

import { API_CALL_SUCCESS } from 'actions/actionConstants'
import { FETCH_OFFER, FETCH_OFFERS, FETCH_OFFER_SUMMARIES } from 'actions/apiActionConstants'
import { getHeroFinderExperimentKey } from 'lib/optimizely/optimizelyUtils'

const offerMiddleware: Middleware<{}, App.State, Dispatch<any>> = (store) => next => (action) => {
  if (action.api === FETCH_OFFER && action.type === API_CALL_SUCCESS) {
    const state = store.getState()
    const experimentKey = getHeroFinderExperimentKey(action.data.id)
    if (action.data.images?.[1] &&
      experimentKey &&
      state.optimizely.optimizelyExperiments[experimentKey]?.enabled) {
      const [first, second, ...rest] = action.data.images
      action.data.images = [second, first, ...rest]
      action.data.image = second
    }

    return next(action)
  }
  else if ((action.api === FETCH_OFFERS || action.api === FETCH_OFFER_SUMMARIES) && action.type === API_CALL_SUCCESS) {
    const state = store.getState()
    action.data.forEach((offer) => {
      const experimentKey = getHeroFinderExperimentKey(offer.id)
      if (offer.images?.[1] &&
        experimentKey &&
        state.optimizely.optimizelyExperiments[experimentKey]?.enabled) {
        const [first, second, ...rest] = offer.images
        offer.images = [second, first, ...rest]
        offer.image = second
      }
    })
  }

  return next(action)
}

export default offerMiddleware
